import React from 'react';
import Alert from 'components/shared/Alert';
import { Spinner } from 'ui/index';
import Text, { TEXT_VARIANTS } from 'ui/Typography/Text';
import NoActivitySvg from './svg/NoActivitySvg';

const Finish = ({ userRedirect }) => {
  if (userRedirect) {
    return (
      <div className="LessonGenerateModal--redirect">
        <Spinner className="mr-12" />
        <Text variant={TEXT_VARIANTS.BODY_LIGHT} aria-live="assertive">
          {t('actions.lesson_generate_modal.returning_content_page')}
        </Text>
      </div>
    );
  }
  return (
    <>
      <Alert icon="alert">
        {t('actions.lesson_generate_modal.remember_review')}
      </Alert>
      <NoActivitySvg />
    </>
  );
};

export default Finish;
